// extracted by extract-css-chunks-webpack-plugin
module.exports = {"content":"content_yM4J+"};